import React from "react";
import iconLoading from "../../assets/img/Loader5.gif";

const LoadingScreen = () => {
  return (
    <>
      <div
        style={{
          display: "grid",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
          justifyItems: "center",
          gap: "20px",
          height: "100%",
        }}
      >
        <img src={iconLoading} width={100} alt="loading" />
        <span style={{ fontSize: "24px" }}>
          Please wait while loading the resources
        </span>
      </div>
    </>
  );
};

export default LoadingScreen;
